import { getMessages } from '../../../../../../../store/constants';

export const MY_WORK_FILTER_BAR_BUTTON_FILTER = getMessages().getText('assigned_to_me.filter_bar.filter');
export const MY_WORK_FILTER_BAR_TOOLTIP_FILTER_OPEN = getMessages().getText('assigned_to_me.filter_bar.filter.tooltip.open');
export const MY_WORK_FILTER_BAR_TOOLTIP_FILTER_CLOSE = getMessages().getText('assigned_to_me.filter_bar.filter.tooltip.close');
export const MY_WORK_FILTER_BAR_ACTIONS_TOOLTIP = getMessages().getText('assigned_to_me.filter_bar.actions.tooltip');

export const TOP_BAR_Z_INDEX = '130';
